const stringToReactNodesWithLinks = (text: string) => {
  // text may be a value like "Note: INRT-1871 - Refactor financial calculation outputs to support breaking out battery revenues"
  // Find any instances of strings which match "INRT-<number>" and convert to a link to the relevant Linear ticket
  // Do the same for any detected URLs and convert to a link
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  // Match both Linear tickets and URLs in userNote, in order of appearance
  const regex = /(INRT-(\d+))|(https?:\/\/[^\s]+)/g;
  while ((match = regex.exec(text)) !== null) {
    // match[1] is the full Linear ticket, match[2] is the ticket number, match[3] is the URL
    parts.push(text.substring(lastIndex, match.index));
    if (match[1]) {
      // Linear ticket
      const ticketNumber = match[1];
      const ticketId = match[2];
      const url = `https://linear.app/inrange/issue/INRT-${ticketId}`;
      parts.push(
        <a
          key={`linear-${match.index}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="notes-link"
        >
          {ticketNumber}
        </a>
      );
    } else if (match[3]) {
      // URL
      const url = match[3];
      parts.push(
        <a
          key={`url-${match.index}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="notes-link"
        >
          {url}
        </a>
      );
    }
    lastIndex = match.index + match[0].length;
  }
  parts.push(text.substring(lastIndex));
  return parts;
};

export default stringToReactNodesWithLinks;
